import { Route } from './Route'
import { Subroute } from './Subroute'
import { InvalidMagicLinkRoute } from './InvalidMagicLinkRoute'
import { CatalogRoute } from 'src/catalog/routes/CatalogRoute'
import { GiftStoreRoute } from 'src/gift_store/routes/GiftStoreRoute'
import { CampaignsRoute } from 'src/campaigns/routes/CampaignsRoute'
import { DashboardRoute } from 'src/dashboard/routes/DashboardRoute'
import { ImportContactsRoute } from 'src/contacts/routes/ImportContactsRoute'
import { OrdersRoute } from 'src/orders/routes/OrdersRoute'
import { PricingRoute } from 'src/marketing/plans/routes/PricingRoute'
import { CardRoute } from 'src/card/routes/CardRoute'
import { RelationshipManagerRoute } from 'src/contacts/routes/RelationshipManagerRoute'
import { GroupsRoute } from 'src/contacts/routes/GroupsRoute'
import { AwardsRoute } from 'src/dashboard/routes/AwardsRoute'

export const BaseSubroute = Subroute(
  InvalidMagicLinkRoute,
  AwardsRoute,
  CampaignsRoute,
  CatalogRoute,
  DashboardRoute,
  GiftStoreRoute,
  ImportContactsRoute,
  OrdersRoute,
  PricingRoute,
  GroupsRoute,
  RelationshipManagerRoute,
  CardRoute,
)
export type BaseSubroute = Subroute<typeof BaseSubroute>

export const BaseRoute = Route({
  path: '/',
  init: (
    subroute: BaseSubroute = CatalogRoute(),
    args: {
      [key: string]: string | undefined
    } = {},
  ): {
    subroute: BaseSubroute
    args: {
      [key: string]: string | undefined
    }
  } => ({
    subroute,
    args,
  }),
  fromPath: () => ({ args: {} }),
  subroute: BaseSubroute,
  subrouteIsRequired: true,
})
// Declared as an interface to avoid self-reference issues
export interface BaseRoute {
  path: '/'
  subroute: BaseSubroute
  args: {
    [key: string]: string | undefined
  }
}
